import { ActivityLogsList } from "#src/batteries-included-components/Layouts/ActivityLogs/ActivityLogsList";
import { AssetType } from "@validereinc/domain";
import React from "react";
import { DeviceUpdateStatusBanner } from "../DeviceUpdateStatusBanner";

export const ChangeLogTab = ({ resourceId }: { resourceId: string }) => {
  return (
    <>
      <DeviceUpdateStatusBanner />
      <ActivityLogsList
        resourceId={resourceId}
        resourceType={{ name: AssetType.DEVICE }}
      />
    </>
  );
};
